import type { ReactNode } from "react";
import { Icon } from "../ui";

/** A full-page message on the brand gradient: while signing in, when something stops the portal starting. */
export function Splash({ text, detail, tone = "info", action }: { text: ReactNode; detail?: ReactNode; tone?: "info" | "error"; action?: ReactNode }) {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "var(--gradient-glow),var(--gradient-deep)" }}>
      <div style={{ width: "100%", maxWidth: 520, background: "var(--surface-card)", borderRadius: "var(--radius-2xl)", boxShadow: "var(--shadow-lg)", padding: "36px 40px", display: "flex", flexDirection: "column", gap: 18, alignItems: "flex-start", animation: "av-rise var(--dur-slow) var(--ease-out)" }}>
        <img src="/logo-wordmark.png" alt="AutoVouch" style={{ height: 36 }} />
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {tone === "error" ? (
            <span style={{ width: 36, height: 36, borderRadius: 12, background: "var(--status-mismatch-bg)", color: "var(--status-mismatch-fg)", display: "flex", alignItems: "center", justifyContent: "center" }}><Icon name="circle-alert" size={20} /></span>
          ) : (
            <Icon name="loader-circle" size={22} style={{ color: "var(--text-brand)", animation: "av-spin 1s linear infinite" }} />
          )}
          <h1 style={{ font: "800 24px/1.15 var(--font-display)", margin: 0 }}>{text}</h1>
        </div>
        {detail && <p style={{ margin: 0, font: "var(--type-body)", color: "var(--text-muted)" }}>{detail}</p>}
        {action}
      </div>
    </div>
  );
}
